// --- React ---
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// --- Services ---
import parameterUnitSvc from "../../../services/api/parameterUnit";

// --- Components ---
import ParameterCreateUpdate from "./create-update";
import { ParameterUnitItem } from "../../../models/types/parameterUnit";
import Loading from "../../../components/loading/loading";

export default function ParameterCreateUpdatePage() {
    const { id } = useParams<{ id?: string }>();

    const isCreate = !id;
    const [data, setData] = useState<ParameterUnitItem | null>(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (id) {
            setLoading(true);
            parameterUnitSvc.getParameterUnitById(id).then((res) => {
                setData(res.content);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [id]);
    return (
        <div className="page-wrapper h-full">
            {loading ? <Loading /> : <ParameterCreateUpdate isCreate={isCreate} data={data} />}
        </div>
    );
}